import { GridCellProps } from '@progress/kendo-react-grid';
import createGridCustomCells from '@components-clean/core/grid/custom-cell';
import { DateCell, EvaluationScoreCell, YesNoCell } from '@components-clean/core/grid-fe/custom-cells';
import { GridColumnProps } from '@components-clean/core/grid-fe/grid.interface';

const reviewedStatusKeys = ['Reviewed', 'Unreviewed'];
const { TooltipCell } = createGridCustomCells();
export const GridColumns: GridColumnProps[] = [
    {
        id: 'id',
        field: 'ProductID',
        title: 'ID',
        minWidth: 60,
        filter: 'numeric',
        lockedByDefault: true,
    },
    {
        id: 'title',
        field: 'Title',
        title: 'Title',
        minWidth: 150,
        lockedByDefault: true,
    },
    {
        id: 'description',
        field: 'Description',
        title: 'Description',
        minWidth: 250,
        filter: 'text',
        cells: {
            data: TooltipCell({
                isCsv: false,
            }),
        },
    },
    {
        id: 'datasetDate',
        field: 'datasetDate',
        title: 'Date',
        minWidth: 140,
        filter: 'date',
        cells: { data: DateCell },
        cellName: 'DateCell',
    },
    {
        id: 'reviewed',
        field: 'reviewedStatus',
        title: 'Review Status',
        minWidth: 140,
        customColumn: true,
        filter: 'text',
        lovData: reviewedStatusKeys.map((key) => key),
    },
    {
        title: 'Active',
        id: 'active',
        field: 'isActive',
        cells: { data: YesNoCell },
        filter: 'boolean',
        minWidth: 110,
    },
    {
        id: 'score',
        field: 'score',
        title: 'Score',
        minWidth: 110,
        filter: 'numeric',
        filterKey: 'score',
        cells: { data: (props: GridCellProps) => EvaluationScoreCell({ ...props, numberFormat: '0.00' }) },
        ragColumn: true,
        singleValueRagColumn: true,
        evaluationColumn: true,
        multiValueExportTitles: {
            score: 'Score',
            colour: 'Color',
        },
    },
];
